/**
 * BPP Backend API (Version: 1.0.0.0)
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export enum DeckungsRegion {
    Oesterreich = 'Oesterreich',
    Europa = 'Europa',
    WeltExklUsaCaAusNz = 'WeltExklUsaCaAusNz',
    WeltInklUsaCaAusNz = 'WeltInklUsaCaAusNz'
  }

    export const DeckungsRegionTranslocoMap: Record<DeckungsRegion, string> = {
    [DeckungsRegion.Oesterreich]: 'deckungsRegion.oesterreich',
    [DeckungsRegion.Europa]: 'deckungsRegion.europa',
    [DeckungsRegion.WeltExklUsaCaAusNz]: 'deckungsRegion.weltExklUsaCaAusNz',
    [DeckungsRegion.WeltInklUsaCaAusNz]: 'deckungsRegion.weltInklUsaCaAusNz',
    };

    export const DeckungsRegionOptions = [
  { value: DeckungsRegion.Oesterreich, labelKey: 'deckungsRegion.oesterreich' },
  { value: DeckungsRegion.Europa, labelKey: 'deckungsRegion.europa' },
  { value: DeckungsRegion.WeltExklUsaCaAusNz, labelKey: 'deckungsRegion.weltExklUsaCaAusNz' },
  { value: DeckungsRegion.WeltInklUsaCaAusNz, labelKey: 'deckungsRegion.weltInklUsaCaAusNz' },
    ];

